var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconWarning"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8389 3.17398C11.36 2.27534 12.64 2.27534 13.1611 3.17398L22.7806 19.5C23.3095 20.4121 22.843 21.5 21.8006 21.5H2.19944C1.15703 21.5 0.690456 20.4121 1.21939 19.5L10.8389 3.17398ZM13.4701 19C13.4701 19.7557 12.8186 20.5 12 20.5C11.0199 20.5 10.5167 19.6747 10.5167 18.919C10.5167 18.1634 11.1803 17.5508 11.9989 17.5508C12.8175 17.5508 13.4701 18.2443 13.4701 19ZM12 6.5C11.2558 6.5 10.744 7.24434 10.744 8V14.8143C10.744 15.5699 11.2558 16.5 12 16.5C12.7442 16.5 13.2055 15.5699 13.2055 14.8143V8C13.2055 7.24434 12.7442 6.5 12 6.5Z",
    fill: "#FFC227"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/iconWarning.724d69b628d0540025d474bcad35573b.svg";
export { ForwardRef as ReactComponent };